import { render, staticRenderFns } from "./NlClipboardButton.vue?vue&type=template&id=5f3cbf55&scoped=true&"
import script from "./NlClipboardButton.vue?vue&type=script&lang=js&"
export * from "./NlClipboardButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3cbf55",
  null
  
)

export default component.exports